import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const postWhitelistDomainSlice = createApi(`PostWhitelistDomainSlice`,"POST");

const PostWhitelistDomainSlice = createSlice({
  name: 'PostWhitelistDomainSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postWhitelistDomainSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postWhitelistDomainSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postWhitelistDomainSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PostWhitelistDomainSlice.reducer;